const journalIssues = [
  {
    id: '2024-12',
    year: 2024,
    issueLabel: '2024年第12期',
    publishDate: '2024-12-15',
    volumeInfo: '第45卷，第12期 - 2024年12月',
    badge: '最新发布',
    coverImage: require('@/assets/img/code/img_1.jpg'),
    summary: '本期聚焦于后全球化时代的柔性供应链管理与企业数字化转型实践，探讨 AI 驱动决策引擎如何提升运营韧性，并收录 ESG 标准本土化的研究报告。',
    issn: '1003-6067',
    serialNo: '总第 458 期',
    pdfReady: false,
    pdfUrl: '',
    content: {
      title: '重塑管理的边界：后全球化时代的组织演进',
      author: '本刊编辑部',
      monthLabel: '2024年12月',
      heroImage: require('@/assets/img/code/img_9.jpg'),
      paragraphs: [
        '在全球经济格局经历深刻重构的今天，管理者们正站在一个新的十字路口。过去三十年支撑全球增长的效率优先逻辑，正逐渐让位于以“韧性”和“敏捷”为核心的新范式。',
        '供应链的脆弱性在近年来的全球突发事件中显露无遗。中国制造企业作为全球价值链的关键环节，其数字化转型已进入“深水区”。本期封面文章聚焦如何将碎片化的信息孤岛转化为实时的协同网络。',
        '同时，我们不能忽视管理中的人文尺度。ESG（环境、社会与治理）标准的本土化实践，正成为中国企业走向全球化 2.0 阶段的必修课。'
      ],
      quotes: [
        '未来的管理不再是关于控制，而是关于赋能。我们需要构建的是能够自我学习、自我修复的“有机组织”，而非僵化的科层机器。',
        '技术不应是冰冷的监控工具，而应成为人类智慧的延伸。通过联邦学习等可信技术，我们可以平衡商业机密与生态协同的矛盾。'
      ]
    }
  },
  {
    id: '2024-11',
    year: 2024,
    issueLabel: '2024年第11期',
    publishDate: '2024-11-18',
    volumeInfo: '第45卷，第11期 - 2024年11月',
    badge: '2024年11月出版',
    coverImage: require('@/assets/img/code/img_2.jpg'),
    summary: '围绕组织敏捷与流程再造展开，收录多行业数字化转型案例复盘，强调组织能力建设与数据治理的协同演进。',
    issn: '1003-6067',
    serialNo: '总第 457 期',
    pdfReady: false,
    pdfUrl: '',
    content: {
      title: '敏捷组织的三条主线：战略、流程与人才',
      author: '编辑部',
      monthLabel: '2024年11月',
      heroImage: require('@/assets/img/code/img_10.jpg'),
      paragraphs: [
        '敏捷不是单点工具，而是战略与能力体系的整合。企业需要在战略拉通、流程重塑与人才机制上形成闭环。',
        '当流程与数据标准一致后，跨部门协同的成本将大幅下降，组织的响应速度与交付质量随之提升。'
      ],
      quotes: []
    }
  },
  {
    id: '2024-10',
    year: 2024,
    issueLabel: '2024年第10期',
    publishDate: '2024-10-20',
    volumeInfo: '第45卷，第10期 - 2024年10月',
    badge: '2024年10月出版',
    coverImage: require('@/assets/img/code/img_3.jpg'),
    summary: '关注产业链协同与风险管理，梳理企业在不确定性环境下的经营策略与供应链治理框架。',
    issn: '1003-6067',
    serialNo: '总第 456 期',
    pdfReady: false,
    pdfUrl: '',
    content: {
      title: '不确定性时代的经营韧性：从风险到机会',
      author: '专题策划',
      monthLabel: '2024年10月',
      heroImage: require('@/assets/img/code/img_11.jpg'),
      paragraphs: [
        '经营韧性来自对关键风险的识别与对资源弹性的配置。管理者需要把“预案”变成“机制”，将组织从被动防御转向主动演进。'
      ],
      quotes: []
    }
  },
  {
    id: '2023-12',
    year: 2023,
    issueLabel: '2023年第12期',
    publishDate: '2023-12-16',
    volumeInfo: '第44卷，第12期 - 2023年12月',
    badge: '过刊存档',
    coverImage: require('@/assets/img/code/img_4.jpg'),
    summary: '回顾年度管理创新实践，提炼高质量发展路径与管理工具方法，聚焦降本增效与协同治理。',
    issn: '1003-6067',
    serialNo: '总第 446 期',
    pdfReady: false,
    pdfUrl: '',
    content: {
      title: '管理创新的年度复盘：方法、机制与组织能力',
      author: '编辑部',
      monthLabel: '2023年12月',
      heroImage: require('@/assets/img/code/img_12.jpg'),
      paragraphs: [
        '年度复盘不仅是总结，更是把经验沉淀为可复制的方法。管理创新应当以问题为导向，以机制为抓手，以数据为支撑。'
      ],
      quotes: []
    }
  }
]

export function getJournalIssues () {
  return journalIssues.slice()
}

export function getJournalYears () {
  const years = journalIssues.map(item => item.year)
  return Array.from(new Set(years)).sort((a, b) => b - a)
}

export function getJournalById (id) {
  const normalized = String(id)
  return journalIssues.find(item => item.id === normalized) || null
}

export function getHomeJournalIssues (limit = 2) {
  return journalIssues.slice(0, limit).map(item => ({
    id: item.id,
    issue: item.issueLabel,
    image: item.coverImage
  }))
}



// WEBPACK FOOTER //
// ./src/utils/journal.js